import { post } from '../axios'

export const agreement = (params) => post('/openapi/verification/v2/cir-report-exp-privacy-policy', params)
export const agreementOtp = (params) => post('/openapi/verification/v2/cir-report-exp-generate-otp', params)
export const cirReportExp = (params) => post('/openapi/verification/v2/cir-report-exp', params)
